/* Fenway uses native module variants. Explicit image IDs are independent of SEO alt/filename edits.
   v2 (wnf-fenway-pdp-2026-10-03, sections/wnf-fenway-v2.liquid): copy of wnf-fenway.js with the cart, gallery and
   recipe logic unchanged. Adds: module landings (?variant= without ?shape=) open a layout that uses that module and
   show a note; layout cards, delivery line and free-delivery nudge follow the selection; sticky bar hides from the
   closing band down; labels without dashes; Fabric Protection / White Glove add-ons join the layout request. */
(function () {
  'use strict';
  var node = document.getElementById('fb-product-data');
  var root = document.querySelector('.fenway-bundle');
  if (!node || !root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var data = JSON.parse(node.textContent);
  var variants = data.variants;
  var recipes = {
    '3pc-l-right': ['Fenway End Left', 'Fenway One Seater', 'Fenway Chaise Right'],
    '3pc-l-left': ['Fenway Chaise Left', 'Fenway One Seater', 'Fenway End Right'],
    '4pc-l-right': ['Fenway End Left', 'Fenway One Seater', 'Fenway One Seater', 'Fenway Chaise Right'],
    '4pc-l-left': ['Fenway Chaise Left', 'Fenway One Seater', 'Fenway One Seater', 'Fenway End Right'],
    'u-4pc': ['Fenway Chaise Left', 'Fenway One Seater', 'Fenway One Seater', 'Fenway Chaise Right']
  };
  var labels = {'3pc-l': '3-Piece L', '4pc-l': '4-Piece L', 'u-4pc': '4-Piece U'};
  var state = {shape: '3pc-l', direction: 'right', color: data.defaultColor, view: 'photo'};
  var busy = false;
  var uncertain = false;
  var failedPhoto = null;
  var byId = function (id) { return document.getElementById(id); };
  var money = function (cents) { return new Intl.NumberFormat('en-US', {style: 'currency', currency: data.currency || 'USD', maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100); };
  var key = function () { return state.shape === 'u-4pc' ? 'u-4pc' : state.shape + '-' + state.direction; };
  var find = function (config) { return variants.find(function (v) { return v.color === state.color && v.config === config; }); };
  function imageFor(kind, item) {
    var group = data.media[kind] && data.media[kind][state.color];
    return group && data.images[String(group[item])] || null;
  }
  function imageWidth(src, width) {
    return src.replace(/([?&])width=\d+/, '$1width=' + width);
  }
  function selection() {
    var counts = {};
    recipes[key()].forEach(function (config) { counts[config] = (counts[config] || 0) + 1; });
    var rows = Object.keys(counts).map(function (config) { return {config: config, quantity: counts[config], variant: find(config)}; });
    return {rows: rows, total: rows.reduce(function (n, r) { return n + (r.variant ? r.variant.price * r.quantity : 0); }, 0),
      available: rows.every(function (r) { return canOrder(r.variant, r.quantity); }),
      timing: rows.some(function (r) { return !r.variant || !r.variant.tracked || r.variant.quantity < r.quantity; })};
  }
  function canOrder(v, quantity) { return !!v && v.available && (!v.tracked || v.policy === 'continue' || v.quantity >= quantity); }
  function description() { return labels[state.shape] + (state.shape === 'u-4pc' ? ' · dual chaise' : ' · ' + state.direction + ' chaise') + ' · ' + state.color; }
  function readUrl() {
    var q = new URL(location.href).searchParams;
    var variant = variants.find(function (v) { return String(v.id) === q.get('variant'); });
    state.color = variant ? variant.color : data.defaultColor;
    state.shape = labels[q.get('shape')] ? q.get('shape') : '3pc-l';
    state.direction = q.get('direction') === 'left' ? 'left' : 'right';
    // A module link (Shopping ads, feeds, collection swatches) carries ?variant= but no layout. Open a layout that
    // uses that module: left-side modules (Chaise Left, End Right) only appear in left-chaise L layouts.
    state.landing = variant && !q.get('shape') ? variant : null;
    if (state.landing && !q.get('direction') && /Chaise Left|End Right/.test(variant.config)) state.direction = 'left';
    if (q.get('color') && variants.some(function (v) { return v.color === q.get('color'); })) state.color = q.get('color');
  }
  function writeUrl() {
    var url = new URL(location.href);
    url.searchParams.set('shape', state.shape);
    url.searchParams.set('direction', state.direction);
    url.searchParams.set('color', state.color);
    var current = variants.find(function (v) { return String(v.id) === url.searchParams.get('variant') && v.color === state.color; });
    url.searchParams.set('variant', String(current ? current.id : find(recipes[key()][0]).id));
    history.replaceState({}, '', url);
  }
  function radio(group, value, attr) {
    document.querySelectorAll(group).forEach(function (button) {
      var selected = button.dataset[attr] === value;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-checked', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
  }
  function renderGallery() {
    var hero = byId('fb-hero-img'), photo = imageFor('hero', key());
    var broken = photo && failedPhoto === photo.hero;
    root.classList.toggle('is-dimensions', state.view === 'dimensions');
    root.classList.toggle('is-photo-missing', !photo || broken);
    if (photo) {
      var responsive = [700, 1000, 1400].map(function (width) { return imageWidth(photo.hero, width) + ' ' + width + 'w'; }).join(', ');
      if (hero.getAttribute('srcset') !== responsive) hero.setAttribute('srcset', responsive);
      if (hero.getAttribute('src') !== photo.hero) hero.src = photo.hero;
      hero.alt = 'Fenway ' + description();
      byId('fb-thumb-photo').src = photo.tile;
    }
    byId('fb-photo-status').hidden = !!photo && !broken;
    byId('fb-photo-status').textContent = broken ? 'The photo could not load. View the layout diagram or try another selection.' : photo ? '' : 'Photo unavailable for this selection. View the layout diagram or ask our team.';
    byId('fb-zoom-open').disabled = !photo || broken || state.view === 'dimensions';
    byId('fb-diagram-detail').hidden = state.view !== 'dimensions';
    byId('fb-diagram-size').textContent = (state.shape === '3pc-l' ? '110' : '140') + '" W × 52.25" D';
    root.querySelector('.fb-hero-dims').setAttribute('aria-label', description() + ', ' + byId('fb-diagram-size').textContent);
    byId('fb-gallery-caption').textContent = description();
    document.querySelectorAll('.fb-thumb').forEach(function (button) {
      var active = button.dataset.view === state.view;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
      button.removeAttribute('aria-selected');
    });
  }
  var moduleNames = {'Fenway One Seater': 'armless seat', 'Fenway Chaise Right': 'right chaise', 'Fenway Chaise Left': 'left chaise', 'Fenway End Right': 'right-arm end', 'Fenway End Left': 'left-arm end'};
  var layoutConfigs = {'3pc-l': recipes['3pc-l-right'], '4pc-l': recipes['4pc-l-right'], 'u-4pc': recipes['u-4pc'], '2pc-l': ['Fenway End Left', 'Fenway Chaise Right']};
  function totalOf(configs) {
    return configs.reduce(function (n, config) { var v = find(config); return n === null || !v ? null : n + v.price; }, 0);
  }
  function orderable(configs) {
    var counts = {};
    configs.forEach(function (config) { counts[config] = (counts[config] || 0) + 1; });
    return Object.keys(counts).every(function (config) { return canOrder(find(config), counts[config]); });
  }
  // Add-on offers (Fabric Protection per module, White Glove once): added in the same request as the layout.
  var addons = Array.from(document.querySelectorAll('[data-wf-addon]'));
  function pieceCount(rows) { return rows.reduce(function (n, r) { return n + r.quantity; }, 0); }
  function addonLines(rows) {
    var n = pieceCount(rows);
    return addons.filter(function (a) { return a.checked && Number(a.dataset.variantId) > 0; }).map(function (a) {
      var quantity = a.dataset.qty === 'pieces' ? n : 1;
      return {id: Number(a.dataset.variantId), quantity: quantity, price: Number(a.dataset.unit) * quantity};
    });
  }
  function setText(selector, text) { document.querySelectorAll(selector).forEach(function (el) { el.textContent = text; }); }
  function renderStory(selected) {
    var total = selected.available ? selected.total : 0;
    // Delivery line by rate-card tier (snippets/wnf-delivery-promise.liquid: $1,500 local, $5,000 statewide).
    var tier = total >= 500000 ? 'oregon' : total >= 150000 ? 'local' : 'under';
    document.querySelectorAll('[data-wf-deliv] [data-wnf-deliv-tier]').forEach(function (el) { el.hidden = el.dataset.wnfDelivTier !== tier; });
    // Free-delivery nudge: only when this layout is under $1,500 and the 4-piece L in the same fabric clears it.
    var nudge = document.querySelector('[data-wf-nudge]');
    if (nudge) {
      var fee = Number(nudge.dataset.fee) || 0, four = totalOf(recipes['4pc-l-' + state.direction]);
      var show = selected.available && state.shape === '3pc-l' && total < 150000 && four !== null && four >= 150000 && orderable(recipes['4pc-l-' + state.direction]);
      nudge.hidden = !show;
      if (show) {
        setText('[data-wf-nudge-with]', money(total + fee));
        setText('[data-wf-nudge-four]', money(four));
        setText('[data-wf-nudge-diff]', money(four - total - fee));
      }
    }
    // Layout cards: price in the selected fabric, and which one is selected.
    document.querySelectorAll('[data-wf-layout]').forEach(function (card) {
      var t = totalOf(layoutConfigs[card.dataset.wfLayout] || []);
      var price = card.querySelector('[data-wf-layout-price]');
      if (price) price.textContent = t === null ? 'Ask us' : money(t);
      card.classList.toggle('is-selected', card.dataset.wfLayout === state.shape);
    });
    setText('[data-wf-fabric]', state.color);
    setText('[data-wf-summary]', labels[state.shape] + ' in ' + state.color + (selected.available ? ', ' + money(selected.total) : ''));
    // Module landing note.
    var note = byId('fb-landing-note');
    if (note) {
      var landing = state.landing && state.landing.color === state.color ? state.landing : null;
      note.hidden = !landing;
      if (landing) {
        var link = document.createElement('a');
        link.href = '#fb-mix';
        link.textContent = 'Buy just that piece';
        note.replaceChildren(document.createTextNode('You picked the ' + (moduleNames[landing.config] || landing.config) + ' (' + money(landing.price) + '), shown here in a full ' + labels[state.shape] + '. '), link, document.createTextNode('.'));
      }
    }
  }
  function render() {
    var selected = selection();
    root.dataset.shape = state.shape;
    root.dataset.direction = state.direction;
    radio('.fb-shape', state.shape, 'shape');
    radio('.fb-toggle button', state.direction, 'direction');
    radio('.fb-sw', state.color, 'color');
    document.querySelector('.fb-direction-row').hidden = state.shape === 'u-4pc';
    byId('fb-shape-name').textContent = labels[state.shape];
    byId('fb-color-name').textContent = state.color;
    byId('fb-mix-fabric').textContent = state.color;
    byId('fb-footprint-val').textContent = (state.shape === '3pc-l' ? '110' : '140') + '" W × 52.25" D';
    var list = byId('fb-included-list');
    list.replaceChildren();
    selected.rows.forEach(function (row) {
      var li = document.createElement('li'), name = document.createElement('span'), price = document.createElement('span');
      name.textContent = row.quantity + ' × ' + row.config.replace(/^Fenway /, '') + (row.config === 'Fenway One Seater' ? ' (armless)' : '');
      price.textContent = row.variant ? money(row.variant.price * row.quantity) : 'Unavailable';
      li.append(name, price);
      list.appendChild(li);
    });
    byId('fb-total-price').textContent = selected.available ? money(selected.total) : 'Unavailable';
    byId('fb-availability').textContent = !selected.available ? 'This complete layout is unavailable. Choose another shape or fabric.' : selected.timing ? 'Available to order. Some pieces need a timing check before delivery or pickup.' : 'Available to order. We confirm delivery or pickup timing for your layout.';
    var extras = addonLines(selected.rows).reduce(function (n, l) { return n + l.price; }, 0), pieces = pieceCount(selected.rows);
    setText('[data-wf-pieces]', String(pieces));
    addons.forEach(function (a) {
      if (a.dataset.qty === 'pieces') setText('[data-wf-fp-total]', money(Number(a.dataset.unit) * pieces));
      var item = a.closest('[data-wnfo-item]');
      if (item) item.classList.toggle('is-checked', a.checked);
      a.disabled = busy;
    });
    var primary = byId('fb-add-btn');
    primary.disabled = busy || uncertain || !selected.available;
    primary.textContent = busy ? 'Adding…' : uncertain ? 'Check your cart before adding again' : selected.available ? 'Add to cart · ' + money(selected.total + extras) : 'Layout unavailable';
    document.querySelectorAll('.fb-shape,.fb-sw,.fb-toggle button').forEach(function (button) { button.disabled = busy; });
    document.querySelectorAll('.fb-mod[data-module]').forEach(function (tile) {
      var v = find(tile.dataset.module), img = tile.querySelector('img'), photo = imageFor('tile', tile.dataset.module), button = tile.querySelector('button');
      if (photo) img.src = photo.tile;
      img.hidden = !photo;
      img.alt = tile.dataset.module + ' in ' + state.color;
      tile.querySelector('.price').textContent = v ? money(v.price) : '—';
      button.disabled = busy || uncertain || !canOrder(v, 1);
      button.textContent = !canOrder(v, 1) ? 'Unavailable' : '+ Add';
      button.setAttribute('aria-label', 'Add ' + tile.dataset.module + ' in ' + state.color + ' to cart');
      tile.querySelector('.fb-module-timing').textContent = !canOrder(v, 1) ? 'Currently unavailable' : !v.tracked || v.quantity < 1 ? 'Confirm arrival timing' : 'Available to order';
    });
    byId('fb-mobile-cta-price').textContent = selected.available ? money(selected.total + extras) : byId('fb-total-price').textContent;
    byId('fb-mobile-cta-shape').textContent = description();
    byId('fb-mobile-cta-btn').disabled = primary.disabled;
    byId('fb-mobile-cta-btn').textContent = busy ? 'Adding…' : uncertain ? 'Check cart' : 'Add to cart';
    renderGallery();
    renderStory(selected);
    document.dispatchEvent(new CustomEvent('wnf:variant-change', {detail: {productId: data.productId, bundleAvailable: selected.available}}));
  }
  function showError(message, ambiguous) {
    var error = byId('fb-error');
    error.replaceChildren(document.createTextNode(message));
    if (ambiguous) {
      var link = document.createElement('a'); link.href = '/cart'; link.textContent = ' Check your cart'; error.appendChild(link);
    }
    error.classList.add('show');
    error.scrollIntoView({block: 'nearest', behavior: 'auto'});
  }
  function select(button) {
    if (busy) return;
    if (button.dataset.shape) state.shape = button.dataset.shape;
    if (button.dataset.direction) state.direction = button.dataset.direction;
    if (button.dataset.color) state.color = button.dataset.color;
    state.landing = null;
    if (!uncertain) byId('fb-error').classList.remove('show');
    writeUrl(); render();
  }
  function reduced() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function toPicker(focusShape) {
    var target = document.querySelector('.fb-shapes');
    if (!target) return;
    target.scrollIntoView({block: 'center', behavior: reduced() ? 'auto' : 'smooth'});
    var active = target.querySelector('.fb-shape.active') || target.querySelector('.fb-shape');
    if (focusShape !== false && active) setTimeout(function () { active.focus({preventScroll: true}); }, 450);
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var pick = event.target.closest('[data-wf-shape]');
    if (pick) {
      var button = document.querySelector('.fb-shape[data-shape="' + pick.dataset.wfShape + '"]');
      if (button) select(button);
      if (pick.hasAttribute('data-wf-scroll')) toPicker();
      return;
    }
    if (event.target.closest('[data-wf-to-picker]')) { toPicker(); return; }
    var chat = event.target.closest('[data-wf-chat]');
    if (chat) {
      var intent = chat.getAttribute('data-chat-intent');
      if (typeof window.WNFChatOpen === 'function') window.WNFChatOpen(intent ? {intent: intent} : undefined);
      else window.location.href = 'tel:+15032353454';
    }
  });
  document.querySelectorAll('.fb-shape,.fb-sw,.fb-toggle button').forEach(function (button) { button.addEventListener('click', function () { select(button); }); });
  root.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
    group.addEventListener('keydown', function (event) {
      var keys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(event.key) || busy) return;
      var buttons = Array.from(group.querySelectorAll('[role="radio"]')), i = buttons.indexOf(document.activeElement);
      if (i < 0) return;
      event.preventDefault();
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (i + (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1) + buttons.length) % buttons.length;
      buttons[next].focus(); select(buttons[next]);
    });
  });
  root.querySelectorAll('[data-view]').forEach(function (button) {
    button.addEventListener('click', function () {
      state.view = button.dataset.view; renderGallery();
      if (button.classList.contains('fb-footprint') && window.innerWidth <= 900) {
        document.querySelector('.fb-gallery').scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        document.querySelector('.fb-thumb[data-view="dimensions"]').focus({preventScroll: true});
      }
    });
  });
  byId('fb-hero-img').addEventListener('error', function () {
    var photo = imageFor('hero', key());
    failedPhoto = photo ? photo.hero : null;
    root.classList.add('is-photo-missing'); byId('fb-photo-status').hidden = false;
    byId('fb-photo-status').textContent = 'The photo could not load. View the layout diagram or try another selection.';
    byId('fb-zoom-open').disabled = true;
  });
  byId('fb-hero-img').addEventListener('load', function () {
    var photo = imageFor('hero', key());
    if (photo && this.getAttribute('src') === photo.hero) {
      failedPhoto = null; root.classList.remove('is-photo-missing');
      byId('fb-photo-status').hidden = true;
      byId('fb-zoom-open').disabled = state.view === 'dimensions';
    }
  });
  var zoom = byId('fb-photo-dialog');
  byId('fb-return-config').addEventListener('click', function () {
    var control = root.querySelector('.fb-footprint');
    control.scrollIntoView({block: 'center', behavior: 'auto'});
    control.focus({preventScroll: true});
  });
  byId('fb-zoom-open').addEventListener('click', function () {
    var photo = imageFor('hero', key());
    if (!photo) return;
    byId('fb-zoom-image').src = imageWidth(photo.hero, 2000);
    byId('fb-zoom-image').alt = 'Fenway ' + description();
    byId('fb-zoom-caption').textContent = description();
    zoom.showModal();
  });
  byId('fb-zoom-close').addEventListener('click', function () { zoom.close(); });
  zoom.addEventListener('close', function () { byId('fb-zoom-open').focus({preventScroll: true}); });
  zoom.addEventListener('click', function (event) {
    var r = zoom.getBoundingClientRect();
    if (event.target === zoom && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) zoom.close();
  });
  async function add(config) {
    if (busy || uncertain) return;
    var selected = selection(), rows = config ? [{config: config, quantity: 1, variant: find(config)}] : selected.rows;
    if (!rows.every(function (row) { return canOrder(row.variant, row.quantity); })) return;
    var bundleId = 'fenway-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var items = rows.map(function (row) {
      var photo = imageFor('tile', row.config);
      var properties = config ? {_source: 'fenway-byo', _fabric: state.color} : {_bundle_id: bundleId, _bundle_label: 'Fenway ' + description(), _fabric: state.color};
      properties._request_id = bundleId;
      if (photo) properties._image = photo.tile;
      return {id: row.variant.id, quantity: row.quantity, properties: properties};
    });
    if (!config) addonLines(rows).forEach(function (line) { items.push({id: line.id, quantity: line.quantity, properties: {_request_id: bundleId}}); });
    busy = true; byId('fb-error').classList.remove('show'); render();
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch((window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: items}), signal: controller.signal});
      var result = await response.json();
      if (!response.ok) {
        // Shopify can return 422 after adding only the available quantity.
        // Read our uniquely marked request before allowing a retry; never assume failure means no change.
        var cartResponse = await fetch((window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store', signal: controller.signal});
        if (!cartResponse.ok) throw new Error('Cart state unknown');
        var cart = await cartResponse.json();
        uncertain = !Array.isArray(cart.items) || cart.items.some(function (item) { return item.properties && item.properties._request_id === bundleId; });
        var message = typeof result.description === 'string' ? result.description : 'This selection could not be added. Check availability or choose another layout.';
        if (uncertain) message += ' Part of this request may be in your cart. Check it before adding again.';
        showError(message, uncertain);
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles: true}));
        if (!config) { window.location.assign('/cart'); return; }
        byId('fb-cart-status').textContent = config + ' added to cart.';
      }
    } catch (error) {
      uncertain = true;
      showError('We could not confirm whether the items were added. Check your cart before trying again.', true);
    } finally { clearTimeout(timer); busy = false; render(); }
  }
  addons.forEach(function (a) { a.addEventListener('change', render); });
  document.querySelectorAll('[data-wnfo-more]').forEach(function (button) {
    button.addEventListener('click', function () {
      var panel = byId(button.getAttribute('aria-controls')), open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });
  byId('fb-add-btn').addEventListener('click', function () { add(); });
  byId('fb-mobile-cta-btn').addEventListener('click', function () { add(); });
  document.querySelectorAll('.fb-mod[data-module]').forEach(function (tile) { tile.querySelector('button').addEventListener('click', function () { add(tile.dataset.module); }); });
  var sticky = byId('fb-mobile-cta');
  function updateSticky() {
    var rect = byId('fb-add-btn').getBoundingClientRect(), close = document.querySelector('[data-wf-close]');
    var show = window.innerWidth <= 900 && rect.bottom < 0 && !(close && close.getBoundingClientRect().top < window.innerHeight);
    sticky.classList.toggle('show', show); sticky.inert = !show; sticky.setAttribute('aria-hidden', String(!show));
  }
  window.addEventListener('scroll', updateSticky, {passive: true});
  window.addEventListener('resize', updateSticky);
  window.addEventListener('pageshow', function () { render(); updateSticky(); });
  window.addEventListener('popstate', function () { readUrl(); render(); });
  readUrl(); render(); updateSticky();
  var pics = Array.from(document.querySelectorAll('#fb-whisperer-photo picture'));
  var first = pics[Math.floor(Math.random() * pics.length)];
  if (first) { first.classList.add('show'); byId('fb-whisperer-name').textContent = first.dataset.name; byId('fb-whisperer-role').textContent = first.dataset.role; }
  byId('fb-whisperer-cta').addEventListener('click', function () { if (window.WNFChatOpen) window.WNFChatOpen(); else window.location.href = '/pages/contact-us'; });
})();
